import {
  AutocompleteInput,
  customScrollMinimal,
  Dropdown,
  DropdownList,
  DropdownProps,
  Input,
  Modal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  ${Modal.Styled.Header} {
    padding-bottom: 16px;
  }

  ${Modal.Styled.TextContainer} {
    margin-top: 12px;
    margin-bottom: 0;
  }

  ${Modal.Styled.ModalContainer} {
    background-color: var(--background-soft);
    display: flex;
    flex-direction: column;
    width: 792px;
    height: 100%;
    max-height: 460px;
    padding: 0;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  height: calc(100% - 62px);
  flex-grow: 1;
  padding: 0px;

  ${Dropdown.Styled.DropdownListContainer} {
    ${customScrollMinimal}
    position: relative;
    overflow-y: auto;
  }
  ${DropdownList.Styled.DropdownListRoot} {
    max-height: none;
    box-shadow: none;
    border: none;
    background-color: unset;
    padding: 0px 0px 12px 8px;
  }
` as <T>(props: DropdownProps<T>) => JSX.Element;

export const HelpText = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  padding: 12px 16px;
`;

export const ClearButton = styled.button`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  cursor: pointer;
  border: none;
  background: none;

  &:hover {
    color: var(--text-default);
  }
`;

export const StyledAutocompleteInput = styled(AutocompleteInput)`
  border-top: 1px solid var(--border-soft);
  border-bottom: 1px solid var(--border-soft);

  ${Input.Styles.LeftIcon} svg {
    fill: var(--text-soft);
  }

  ${Input.Styles.Container} {
    width: 100%;
  }

  ${Input.Styles.InputWrapper} {
    border: none;
    background-color: transparent;
    padding-left: 20px;
  }

  ${Input.Styles.InputElement} {
    text-align: left;
  }
`;
